import React, { createContext, ReactNode, useContext, useState } from 'react';
import { Room } from 'matrix-js-sdk';

type RoomMembersContextValue = {
  room: Room | null;
  setActiveRoom: (room: Room) => void;
  clearActiveRoom: () => void;
};

const RoomMembersContext = createContext<RoomMembersContextValue | null>(null);

export function RoomMembersProvider({ children }: { children: ReactNode }) {
  const [room, setRoom] = useState<Room | null>(null);

  const setActiveRoom = (r: Room) => setRoom(r);
  const clearActiveRoom = () => setRoom(null);

  return (
    <RoomMembersContext.Provider value={{ room, setActiveRoom, clearActiveRoom }}>
      {children}
    </RoomMembersContext.Provider>
  );
}

const noopRoomMembers: RoomMembersContextValue = {
  room: null,
  setActiveRoom: () => undefined,
  clearActiveRoom: () => undefined,
};

export function useRoomMembersCtx(): RoomMembersContextValue {
  const ctx = useContext(RoomMembersContext);
  return ctx ?? noopRoomMembers;
}
